import { Button, Col, Form, Modal } from "react-bootstrap"
import styles from "./pedidos_style.module.css"
import InsumosPedidoTabelaProdutos from "./TabelaProdutos"
import InsumosBtnLoading from "./BtnLoading"
import { useEffect, useState } from "react"
import removeAllErrorMsg from "../../../components/funcRemoveAllErros"
import { getElementFromId, getValueFromInput } from "../../../components/funcForInput"
import Select from "react-select"
import { getCookie } from "../../../config/cookies"
import { ApiEndpoints, reqPut } from "../../../config/apiClient"
import { toast } from "react-toastify"
import funcSleep from "../../../components/funcSleep"

export default function InsumosModalCriarPedido({ show, handleClose, onUpdate, filtrosDados, locaisOptions, produtosOptions, unidadesOptions }: iProps) {
    const [btnIdClick, setBtnIdClick] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)
    const [listaProdutos, setListaProdutos] = useState<any[]>(handleParseListaProdutos([{
        id: null,
        id_pedido: null,
        id_produto: {id_produto: 0},
        id_unidade: {id_unidade: 0},
        qtd: 1,
    }]))
    const [idLocal, setIdLocal] = useState<any>({ "value": 0, "label": "Não Selecionado" })

    useEffect(() => {
        const handleClick = (e:any) => {
            if (e.target.tagName === "BUTTON") {
                // console.log(e.target.id)
                setBtnIdClick(e.target.id)
            }
        }
        document.addEventListener("click", handleClick)

        const id_colaborador = Number(getCookie("id_colaborador"))
        if (id_colaborador <= 0) {
            handleClose()
            toast.warning('O usuário não pode criar pedidos, verifique com o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark',
            })
        }
        // eslint-disable-next-line
    }, [])

    function handleParseListaProdutos(produtos: any[]) {
        let dados: any[] = []
        for (let prod of produtos) {
            dados.push({
                id: prod.id,
                id_pedido: null,
                id_produto: prod.id_produto.id_produto,
                id_unidade: prod.id_unidade.id_unidade,
                qtd: prod.qtd,
            })
        }
        return dados
    }

    function handleChangeListaProdutos(dados: any[]) {
        setListaProdutos(dados)
    }

    function handleLoadLocalProdutos(local: any) {
        let lista_produtos_aux:any[] = []
        const PRODUTOS:any[] = local.produtos
        for (let prod of PRODUTOS) {
            lista_produtos_aux.push({
                id: null,
                id_pedido: null,
                id_produto: prod.id_produto.id_produto,
                id_unidade: prod.id_unidade.id_unidade,
                qtd: prod.qtd,
            })
        }
        setListaProdutos(lista_produtos_aux)
    }

    async function handleSalvarListaProdutos() {
        removeAllErrorMsg()
        if (loading) {
            return
        }
        let formValidado = true
        let dadosForm = {
            id_pedido: null,
            id_colaborador: Number(getCookie("id_colaborador")),
            id_local: Number(idLocal.value),
            id_status: 1,
            observacao: getValueFromInput("observacao"),
            produtos: listaProdutos,
        }
        let possui_prod_duplicado = false
        for (let idx in dadosForm.produtos) {
            let prod = dadosForm.produtos[idx]
            if (prod.qtd <= 0) {
                let inputQtd = getElementFromId(`${idx}-qtd`)
                inputQtd.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (prod.id_produto === 0) {
                let inputProd = getElementFromId(`${idx}-id_produto_aux`)
                inputProd.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (prod.id_unidade === 0) {
                let inputUnid = getElementFromId(`${idx}-id_unidade_aux`)
                inputUnid.nextElementSibling.style.display = "block"
                formValidado = false
            }
            let qtd_encontrado = 0
            for (let prodaux of dadosForm.produtos) {
                if (prodaux.id_produto === prod.id_produto && prodaux.id_unidade === prod.id_unidade) {
                    qtd_encontrado += 1
                }
            }
            if (qtd_encontrado > 1) {
                possui_prod_duplicado = true
            }
        }

        if (dadosForm.id_local === 0) {
            // form.descricao.nextElementSibling.style.display = "block"
            let local_input_aux = getElementFromId("id_local_aux")
            local_input_aux.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (possui_prod_duplicado) {
            window.alert("Verifique a lista, existem produtos duplicados!")
            formValidado = false
        }
        if (dadosForm.produtos.length === 0) {
            window.alert("Lista de produtos está vazia!")
            formValidado = false
        }

        if (!formValidado) {
            return
        }

        cadastrar(dadosForm)
    }

    async function cadastrar(dados: any) {
        setLoading(true)
        const api = await reqPut(ApiEndpoints.insumosCadastrarPedido, dados)
        if (api.status === 201) {
            toast.success('Pedido cadastrado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            onUpdate()
            handleClose()
            await funcSleep(500)
        }
        setLoading(false)
    }

    return (
        <Modal
            id={styles.modal_insumo_pedido}
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={true}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Insumos FAI - Criar Pedido</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <br></br>
                <div className="div-row" style={{ alignItems: "start" }}>
                    <Col className="col-4">
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Local:</Form.Label>
                            <Select name="id_local" id="id_local" options={locaisOptions} value={idLocal} placeholder="Selecione" onChange={
                                (choice: any) => {
                                    console.log(filtrosDados)
                                    setIdLocal(choice)
                                    const ID_LOCAL = Number(choice.value)
                                    const locais:any[] = filtrosDados.locais
                                    const local = locais.filter((reg:any) => reg.id_local === ID_LOCAL)
                                    if (local.length > 0) {
                                        handleLoadLocalProdutos(local[0])
                                    }
                                }
                                } styles={customStyleSelect} />
                                <Form.Control name="id_local_aux" type="text" id="id_local_aux" placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">
                                    Informe o Produto!
                                </Form.Control.Feedback>
                            </Form.Group>
                        <br></br>
                        <Form.Group>
                            <Form.Label>Observação:</Form.Label>
                            <Form.Control as="textarea" rows={8} maxLength={1000} name='observacao' id='observacao' autoComplete='off' />
                        </Form.Group>
                        <br></br>
                    </Col>
                    <Col className="col-8" style={{ margin: "0px 10px" }}>
                        <InsumosPedidoTabelaProdutos id_pedido={null} filtrosDados={filtrosDados} pedido={{}} produtos={listaProdutos} btnIdClick={btnIdClick} unidadesOptions={unidadesOptions} produtosOptions={produtosOptions} onChange={handleChangeListaProdutos} onSave={handleSalvarListaProdutos} loading={loading} />
                    </Col>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ width: "100%" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <div>
                            <Button id="btnCadastrarPedido" variant="success" onClick={() => { handleSalvarListaProdutos() }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnCadastrarPedido" btnIdClick={btnIdClick} loading={loading} /> CADASTRAR SOLICITAÇÃO</Button>
                        </div>
                    <div>
                        <Button variant="secondary" onClick={handleClose}>Fechar</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

interface iProps {
    show: boolean
    filtrosDados: any
    handleClose: any
    unidadesOptions: any[]
    produtosOptions: any[]
    locaisOptions: any[]
    onUpdate: any
}

const customStyleSelect = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        borderColor: "#dee2e6",
        backgroundColor: state.isDisabled ? "#E9ECEF" : "white",
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "black" : "black",
    }),
}

